import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsCtx = {};
let cached = null;

export const useSettings = () => {
  const [settings, setSettings] = useState(cached);
  useEffect(() => {
    if (cached) return;
    api.get("/settings/public").then((r) => { cached = r.data; setSettings(r.data); }).catch(() => {});
  }, []);
  return settings;
};
